const actions = {
    ENCRYPT_REQ_ID: "ENCRYPT_REQ_ID",
    ENCRYPT_REQ_ID_SUCCESS: "ENCRYPT_REQ_ID_SUCCESS",
    ENCRYPT_REQ_ID_LOADING: "ENCRYPT_REQ_ID_LOADING",
    ENCRYPT_REQ_ID_FAILED: "ENCRYPT_REQ_ID_FAILED",

    SET_ENCRYPTED_DATA: "SET_ENCRYPTED_DATA",

    encryptReqId: (payload) => ({
        type: actions.ENCRYPT_REQ_ID,
        payload
    }),
    setEncryptedData: (payload) => ({
        type: actions.SET_ENCRYPTED_DATA,
        payload
    })
};

export default actions;